import { ComponentPropsWithoutRef, FC } from 'react';
import styled from 'styled-components';
import { pxToRem } from '../../utils/pxToRem';
import { colors } from '../colors';
import { Container, ErrorMessage, InputLabel } from '../input';

interface InputProps extends ComponentPropsWithoutRef<'textarea'> {
  errorMessage?: string;
  labelText: string;
}
export const TextAreaWithLabel: FC<InputProps> = ({
  labelText,
  errorMessage,
  className,
  ...rest
}) => {
  return (
    <Container className={className}>
      <InputLabel>{labelText}</InputLabel>
      <TextArea error={!!errorMessage} {...rest} />
      {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Container>
  );
};

export const TextArea = styled.textarea<{ error?: boolean }>`
  background: ${colors.grey};
  border-radius: 8px;
  outline: transparent;
  border: 1px solid ${({ error }) => (error ? colors.danger : colors.greyText)};
  padding: 12px 16px;
  margin-top: 6px;

  &::placeholder {
    font-size: ${pxToRem(14)};
    color: ${colors.greyText};
  }
`;
